export default "__VITE_ASSET__af032b2a__"